var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruIconBlackFlat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 249.13 230",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.13,114.99l-44.62-44.6-41.51-41.51C143.8,9.65,118.51,0,93.32,0H15.84L3.73,21.76H93.32c8.48,0,16.95,1.4,25.04,4.19-19.66,1.41-38.98,9.65-54.01,24.68l-2.76,2.76H3.74l12.11,21.73h24.02L0,114.99l39.88,39.9H15.84l-12.11,21.73H61.61l2.75,2.75c15.03,15.03,34.35,23.27,54.01,24.68-8.09,2.79-16.56,4.19-25.04,4.19H3.73l12.12,21.76H93.32c25.19,0,50.48-9.65,69.67-28.88l41.51-41.51h0l44.62-44.63Zm-30.76,0l-29.26,29.27-29.26-29.25,29.26-29.27,.03,.03,29.23,29.23ZM124.56,47.44c16.14,.03,32.17,6.1,44.57,18.34l4.6,4.6-29.27,29.26-27.89-27.89c-7.15-7.17-15.67-12.19-24.7-15.16,10.03-6.05,21.32-9.13,32.69-9.15Zm-53.93,107.44L30.76,114.99l39.86-39.86h1.7v.03c10.5,0,20.89,3.95,28.88,11.97l27.89,27.89-27.89,27.88c-7.99,8.02-18.38,11.97-28.88,12h-1.68Zm53.93,27.67c-11.36-.02-22.65-3.09-32.67-9.14,9.02-2.97,17.52-7.97,24.68-15.15h.03l27.88-27.89,29.25,29.25-4.59,4.59c-12.37,12.24-28.43,18.31-44.57,18.34Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruIconBlackFlat);
export default __webpack_public_path__ + "static/media/TRU-Icon-Black-Flat.e34c7c2327fa47c75d1d76e5fac9adab.svg";
export { ForwardRef as ReactComponent };